module.exports = __webpack_public_path__ + "assets/img/driver-btn-6aa5b619.png";